export const apiDomain = 'https://api.court51cable.xyz'